import React, { useEffect, useRef, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useForm } from "react-hook-form";
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService';
import DashboardWrapper from './DashboardWrapper';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.Settings';

const DashboardSettings = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const [settings, setSettings] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [byteImage, setByteImage] = useState();
    const [originalImage, setOriginalImage] = useState();
    const formRef = useRef();
    const [showImgPopup, setShowImgPopup] = useState(false);
    const [imageCurrentShow, setImageCurrentShow] = useState('');

    const [settingIdUpdate, setSettingIdUpdate] = useState();
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');

    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            setUploadingImage(false)
            if (uploadingImage) {
                if (data.file[0] !== undefined && data.file[0].name !== null) {
                    await HttpHelper.post("Setting/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                        headers: {
                            'Content-Type': 'multipart/form-data; charset=utf-8',
                        }
                    }).then((response) => {
                        if (response.status === 200) {
                            data.FileId = response.data[0].fileId;
                            delete data.file;
                            SettingUpdate(data, true)
                        } else {
                            console.log('error while uploading the image');
                        }
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            } else {
                SettingUpdate(data, data.settingId, true)
            }

        }
        else {
            if (data.file) {
                if (data.file[0] !== undefined && data.file[0].name !== null) {
                    await HttpHelper.post("Setting/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                        headers: {
                            'Content-Type': 'multipart/form-data; charset=utf-8',
                        }
                    }).then((response) => {
                        if (response.status === 200) {
                            data.FileId = response.data[0].fileId;
                            delete data.file;
                            SettingAdd(data, true)
                        } else {
                            console.log('error while uploading the image');
                        }
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            }
            SettingAdd(data)
        }

    }
    const SettingAdd = async (data, withImg) => {
        delete data.settingId
        if (withImg === true) {
            await HttpHelper.post("Setting", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                setSettings(response.data)
            }).catch((error) => {
                DeleteUploadedFile(data.FileId)
                console.log(error);
            })
        } else {
            await HttpHelper.post("Setting", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                props.showToast('success', 'Setting Added Succesfully');
                GetSetting();
                setSettings(response.data)
            }).catch((error) => {
                console.log(error);
            })
        }
    }
    const SettingUpdate = async (data, id) => {
        Object.assign(data,
            { rowVersion: rowVersion },
            { primaryKeyEncrypted: primaryKeyEncrypted },
            { settingId: settingIdUpdate },
            { FileId: fileIdUpdate },
            { file: fileDetailsUpdate }
        );
        if (uploadingImage) {
            await HttpHelper.put("Setting", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                GetSetting()
            }).catch((error) => {
                DeleteUploadedFile(data.FileId)
                console.log(error);
            })
        } else {
            await HttpHelper.put("Setting", data).then((response) => {
                setLoaderApi(false);
                setPopupAddEdit(false);
                if (response.status === 200) {
                } else {
                    console.log('error while uploading the image');
                }
                GetSetting()
            }).catch((error) => {
                console.log(error);
            })
        }

    }
    const GetSetting = async (data) => {
        setLoaderApi(true);
        await HttpHelper.get("Setting", data).then((response) => {
            setSettings(response.data.data);
            getAllPermission();
            setIsEditing(true);
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })
    }
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Setting/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
            props.showToast('success', 'Image deleted Succesfully');
        }).catch((error) => {
            console.log(error);
        })
    }
    const GetSettingList = async () => {
        //await HttpHelper.get("setting").then((response) => {
        //    if (response.status == 200) {
        //        setSettings(response.data.data);
        //    } else {
        //        console.info(response.data.data);
        //    }
        //}).catch((error) => {
        //    console.log(error);
        //})
    }
    const updateSetting = async (settingId) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        await HttpHelper.get("Setting/" + settingId).then((response) => {
            clearErrors();
            setIsEditing(true);
            if (response.data.isUploaded == true) {
                setUploadingImage(true);
                setValue('IsUploaded', true);
                setByteImage(response.data.byteImage);
                setOriginalImage(response.data.value);
            } else {
                setUploadingImage(false);
                setValue('IsUploaded', false);
            }
            setValue('IsUploaded', false);
            setValue("name", response.data.name);
            setValue("value", response.data.value);
            setValue("description", response.data.description);
            setValue("settingId", response.data.settingId);
            setSettingIdUpdate(response.data.settingId)
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted)
            setRowVersion(response.data.rowVersion)
            accordianStatusHandle('1');

            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            console.log(error);
        })
    }
    const detetSetting = async (settingId) => {
        swal("Are you sure, you want to delete this Setting?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("Setting/" + settingId).then((response) => {
                        clearErrors();
                        props.showToast('success', 'Record Deleted Succesfully');
                        GetSetting();
                    }).catch((error) => {
                        console.log(error);
                    })
                }
            }
            );
    }
    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    const clearField = () => {
        setValue('IsUploaded', false);
        setValue("name", '');
        setValue("value", '');
        setValue("description", '');
        setValue("settingId", '');
    }
    useEffect(() => {
        GetSetting();
        GetSettingList();
    }, []);

    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Website Settings" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    setIsEditing(false);
                                    accordianStatusHandle('1');
                                    clearField();
                                }} className="btn btnSave">Add Setting</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 mb-2 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign" style={{ padding: '0px' }}>
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    Name
                                                </th>
                                                <th >
                                                    Value
                                                </th>
                                                <th>
                                                    Description
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                settings !== undefined && settings.length > 0 ? settings.map((setting, index) => {
                                                    return (<>
                                                        <tr key={index}>
                                                            <td>
                                                                {index + 1}
                                                            </td>
                                                            <td>
                                                                {setting.name}
                                                            </td>
                                                            <td className="td-truncate">
                                                                {setting.isUploaded ?
                                                                    <img src={setting.value} height={"50px"} />
                                                                    : setting.value}
                                                            </td>
                                                            <td>
                                                                {setting.description}
                                                            </td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                {hasEditPermissionUser == true ? <CiEdit onClick={() => { updateSetting(setting.settingId) }} /> : ''}
                                                                &nbsp;
                                                                {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { detetSetting(setting.settingId) }} /> : ''}
                                                            </td>
                                                        </tr>
                                                    </>)
                                                })
                                                    : <tr><td colSpan={5}>No Setting data found!!!</td></tr>
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div>
            {
                hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Setting" : "Create Setting"}</h4>
                                <div className="row">

                                    <div className="col-md-12">
                                        <label>Name : <span class="requiredAstric"> *</span></label>
                                        <input disabled={isEditing} type="text"  {...register('name', { required: true })} placeholder="Name" className="border mb-2 w-100 is-invalid" />
                                        {errors.name?.type === 'required' && <p className="text-danger" role="alert">Name is required</p>}
                                    </div>

                                    <div className="col-md-12">
                                        <label>
                                            <input checked={uploadingImage} type="checkbox" onClick={(e) => {
                                                if (e.currentTarget.checked === true) {
                                                    setUploadingImage(true);
                                                    setValue('IsUploaded', true);
                                                } else {
                                                    setUploadingImage(false);
                                                    setValue('IsUploaded', false);
                                                }
                                            }}  {...register("uploadImage")} className="border mb-2" placeholder="Value" aria-invalid={errors.Heading ? "true" : "false"} />
                                            &nbsp; Want to upload image?
                                        </label>
                                    </div>
                                    {
                                        uploadingImage === true ?
                                            <div className="col-md-12">
                                                <label>File : {uploadingImage ? <span class="requiredAstric"> *</span> : ''}</label>
                                                <input type="file"  {...register('file', { required: uploadingImage })} className="border mb-2 w-100 is-invalid" />
                                                {errors.file?.type === 'required' && <p className="text-danger" role="alert">File is required</p>}
                                                <input type="hidden" {...register('IsUploaded')} />
                                                {
                                                    byteImage ?
                                                        <img src={"data:image/png;base64, " + byteImage} height={"50px"} />
                                                        : null
                                                }
                                            </div>
                                            : null
                                    }
                                    <div className="col-md-12" style={uploadingImage ? { display: 'none' } : { display: 'block' }}>
                                        <label>Value : {uploadingImage == false ? <span class="requiredAstric"> *</span> : ''}</label>
                                        <input type="text"  {...register("value", { required: uploadingImage == false ? true : false })} className="border mb-2" placeholder="Value" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.value?.type === 'required' && <p className="text-danger" role="alert">Value is required</p>}
                                    </div>

                                    <div className="col-md-12">
                                        <label>Description : </label>
                                        <textarea className="border" {...register("description")} placeholder="Description"></textarea>
                                        {errors.description?.type === 'required' && <p className="text-danger" role="alert">Description is required</p>}
                                    </div>
                                    {
                                        isEditing === true ?
                                            <input type="hidden" {...register('settingId')} />
                                            : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-6">
                                        <div>
                                            <button className="btn btnSave mt-2">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''
            }
        </DashboardWrapper >
    )
}

export default DashboardSettings;